import { render, staticRenderFns } from "./embeder.vue?vue&type=template&id=099278f2&"
import script from "./embeder.vue?vue&type=script&lang=js&"
export * from "./embeder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports